import type { SVGProps } from 'react';

const SvgFitViewport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18.92 5.62c-.1-.25-.3-.44-.54-.54A1 1 0 0 0 18 5h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59L13.3 9.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2.29-2.29V10c0 .55.45 1 1 1s1-.45 1-1V6c0-.13-.03-.26-.08-.38zm-9.63 7.67L7 15.58v-1.59c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .13.03.26.08.38.1.25.3.44.54.54.12.05.25.08.38.08h4c.55 0 1-.45 1-1s-.45-1-1-1H8.41l2.29-2.29a.996.996 0 1 0-1.41-1.41"
    />
  </svg>
);
export default SvgFitViewport;
